import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { Card } from "./ui/card";
import { Skeleton } from "./ui/skeleton";
import { Markdown } from "./Markdown";
import { Sparkles } from "lucide-react";

export const RoleBrief = ({ roleId }) => {
  const [brief, setBrief] = useState(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    api.get(`/roles/${roleId}/brief`).then((r) => setBrief(r.data)).catch(() => setFailed(true));
  }, [roleId]);

  if (failed) return null;
  return (
    <Card className="p-8 border-primary/30" data-testid="role-brief">
      <div className="label-caps text-primary mb-4 flex items-center gap-1.5"><Sparkles className="h-3 w-3" />Tribunal role brief</div>
      {!brief ? (
        <div className="space-y-2"><Skeleton className="h-4 w-2/3" /><Skeleton className="h-4 w-1/2" /><Skeleton className="h-4 w-3/4" /></div>
      ) : (
        <>
          <Markdown text={brief.content} testId="role-brief-content" />
          {brief.sources?.length > 0 && (
            <div className="mt-6 pt-4 border-t border-border text-xs text-muted-foreground space-y-1">
              {brief.sources.map((s, i) => (
                <Link key={i} to={`/app/learn/chapter/${s.chapter_id}`} className="block font-mono hover:text-foreground" data-testid={`role-brief-source-${i}`}>[{i + 1}] {s.title}</Link>
              ))}
            </div>
          )}
        </>
      )}
    </Card>
  );
};
